import { FileOutlined } from '@ant-design/icons';
import { AllegatoComunicazioneDTO } from '@framework/api-client';
import { Space } from 'antd';
import * as React from 'react';
import styled from 'styled-components';
import { AttachmentTypeTag } from './AttachmentTypeTag';

const AttachmentItemIcon = styled.span`
  font-size: 16px;
`;

const AttachmentName = styled.span`
  word-wrap: break-word;
  white-space: normal;
  word-break: break-word;
  text-align: left;
`;

export interface IAttachmentItemViewProps {
  attachment?: AllegatoComunicazioneDTO | null | undefined;
}

/**
 * Singolo allegato della comunicazione
 */
export function AttachmentItemView(props: IAttachmentItemViewProps) {
  const { attachment } = props;
  if (!attachment) return null;

  return (
    <Space size={4} wrap style={{ maxWidth: '100%' }}>
      <AttachmentItemIcon>
        <FileOutlined />
      </AttachmentItemIcon>
      <AttachmentName>{attachment.nomeFile}</AttachmentName>
      <AttachmentTypeTag
        mini
        name={attachment.tipoComunicazioneFileAllegatoDTO?.denominazione}
      />
    </Space>
  );
}
